import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MOBILE_OR_TABLET_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type DownloadAndViewCounterTariff = {
    variant: 'a' | 'b' | 'c' | 'd';
    trial: string;
    tariff: string;
};

const value: DownloadAndViewCounterTariff | undefined = getFeature('download-and-view-counter-tariff') || {};

if (!IS_BIZ_USER && !IS_MOBILE_OR_TABLET_BROWSER) {
    registerExperiment('dwn-views-counter', value?.variant, [
        AnalyticEventNames.PUBLIC_INFO_MODAL_SHOW,
        AnalyticEventNames.PUBLIC_INFO_DOWNLOADS,
        AnalyticEventNames.PUBLIC_INFO_VIEWS,
    ]);
}

export const downloadAndViewCounterTariff: DownloadAndViewCounterTariff | undefined =
    !IS_BIZ_USER && !IS_MOBILE_OR_TABLET_BROWSER && value?.variant ? value : undefined;
